import { render, staticRenderFns } from "./MatchedStockList.vue?vue&type=template&id=54ce1928&"
import script from "./MatchedStockList.vue?vue&type=script&lang=js&"
export * from "./MatchedStockList.vue?vue&type=script&lang=js&"
import style0 from "./MatchedStockList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports